import { CardTableHeader, CardTableContent } from './CardTable.parts';
import { BaseCardTableProps } from './types';


export function CardTableDisplay<T>({
  title,
  icon,
  iconColor = 'text-primary',
  titleAside,
  columns,
  data,
  actions,
  onItemClick,
  emptyStateMessage = 'Aucune donnée disponible',
  isLoading,
  loadingComponent,
  headerClassName,
  rowClassName
}: BaseCardTableProps<T>) {
  if (isLoading && loadingComponent) {
    return <>{loadingComponent}</>;
  }

  return (
    <div className="border rounded-xl bg-white shadow-sm overflow-hidden">
      <CardTableHeader
        title={title}
        icon={icon}
        iconColor={iconColor}
        titleAside={titleAside}
        headerClassName={headerClassName}
      />

      <CardTableContent
        columns={columns}
        data={data}
        actions={actions}
        onItemClick={onItemClick}
        rowClassName={rowClassName}
        emptyStateMessage={emptyStateMessage}
      />
    </div>
  );
}
